/* eslint-disable react-hooks/exhaustive-deps */
/* eslint-disable no-useless-computed-key */

import React, { useEffect, useState,  useRef } from 'react';
import customStyles from "../../../../../assets/styles/customStyles";
import SettingsImg from "../../../../../assets/images/icon_menus/SettingsIcon.json";
import MainHeader from "../../../../Shared/components/Header";
import PrimaryCard from "../../../../Shared/components/Card/PrimaryCard";
import clsx from "clsx";
import { Row, Col, Image, Space } from "antd";
import { useDispatch, useSelector } from "react-redux";
import { checkViewPermission, checkCRUDPermission, checkComponentPermission } from '../../../../../helpers/utilities';
import { TextField, } from "@mui/material";
import { NavLink } from "react-router-dom";
import AddIcon from "../../../../../assets/images/icon_actions/Add Icon.svg";
import SearchIcon from "../../../../../assets/images/icon_actions/Search Icon.svg";
import usePrevious from "../../../../Shared/components/Previous";
import crudActions from "../../../../CRUD/redux/actions";
import { ListTable } from './ListTable';
//import FilterIcon from "../../../../../assets/images/icon_actions/Filter Icon.svg";
import DeleteModal from "../../../../Shared/components/DeleteModal";
import { toast } from 'react-toastify';


const PlanDetails = (props) => {
    const { roleManagement } = useSelector(state => state.authReducer);
    const { getList, getData, editDetails, editData } = useSelector(state => state.crudReducer);
    const [search, setSearch] = useState('');
    const classes = customStyles();
    const [iconAnimation, setIconAnimation] = useState(false);
    const [providerId, setProviderId] = useState('');
    const prevSearch = usePrevious(search);
    const timeoutRef = useRef(null);
    const [loadMore, setLoadMore] = useState(false);
    const [loadMoreContent, setLoadMoreContent] = useState(false);
    const [skip, setSkip] = useState(0);
    const limit = 25;
    const { history } = props;
    const dispatch = useDispatch();
    const [sortOrder, setSortOrder] = useState("desc");
    const [sortBy, setSortBy] = useState("id");
    const [name, setName] = useState("");
    const [deleteModal, setDeleteModal] = useState(false);
    const prevEditDetails = usePrevious(editDetails);


    const dispatchFilter = (sortBy, sortOrder, skip = 0) => {
        if (skip === 0) {
            setLoadMore(false);
            setLoadMoreContent(false);
        }
        let filter = { ["or"]: [] };

        if (search !== '') {
            filter['or'].push({ planName: { like: '%' + search.trim() + '%' } });
            filter['or'].push({ planId: { like: '%' + search.trim() + '%' } });
            filter['or'].push({ actualPlanAmount: { like: '%' + search.trim() + '%' } });
            filter['or'].push({ allowedUsers: { like: '%' + search.trim() + '%' } });
            filter['or'].push({ description: { like: '%' + search.trim() + '%' } });
            filter['or'].push({ planAmount: { like: '%' + search.trim() + '%' } });
            filter['or'].push({ planType: { like: '%' + search.trim() + '%' } });
            filter['or'].push({ frequency: { like: '%' + search.trim() + '%' } });
        }

        setSkip(skip);
        dispatch({
            type: crudActions.GET_DETAILS_START,
            url: 'plans',
            skip: skip,
            filter: {
                where: filter,
                order: sortBy + ' ' + sortOrder,
                limit: limit,
                skip: skip
            },
        });
    }

    useEffect(() => {
        if (roleManagement !== '') {
            if (checkViewPermission('Plan Details', history, 'Younote Admin')) {
                dispatchFilter(sortBy, sortOrder)
            }
        }
    }, [roleManagement]);

    const requestSort = (sortBy, sortOrder) => {
        setSortBy(sortBy);
        setSortOrder(sortOrder);
        dispatchFilter(sortBy, sortOrder);
    }

    const loadMoreTask = () => {
        let s = skip + limit;
        dispatchFilter(sortBy, sortOrder, s);
    }

    const onDelete = (data) => {
        setDeleteModal(true);
        setProviderId(data?.id);
        setName(data?.planId);
    }

    const prevGetData = usePrevious(getData);
    useEffect(() => {
        if (loadMore && getData === '') {
            setLoadMoreContent(false);
            setLoadMore(true);
        }
        if (prevGetData !== undefined && getData && prevGetData !== getData) {
            const timer = setTimeout(() => {
                if (getData && Array.isArray(getData) && getData.length > 0) {
                    setLoadMore(true);
                    if (getData.length < limit) {
                        setLoadMoreContent(false);
                    } else {
                        setLoadMoreContent(true);
                    }
                } else {
                    setLoadMoreContent(false);
                    setLoadMore(true);
                }
            });

            return () => {
                clearTimeout(timer);
            };
        }
    }, [getData]);

    useEffect(() => {
        if ((prevSearch !== undefined && search && search.length > 2 && prevSearch !== search) || (prevSearch !== undefined && search === '' && prevSearch !== search)) {
            if (timeoutRef.current !== null) {
                clearTimeout(timeoutRef.current);
            }
            if (search === '') {
                dispatchFilter(sortBy, sortOrder);
            } else {
                timeoutRef.current = setTimeout(() => {
                    timeoutRef.current = null;
                    dispatchFilter(sortBy, sortOrder);
                }, 500);
            }
        }
    }, [search]);

    const handleStatus = (data) => {
        // data.status = data.status !== 'ACTIVE' ? 'DEACTIVE' : 'ACTIVE';
        dispatch({
            type: crudActions.EDIT_DETAILS_START,
            url: "plans",
            id: data.id,
            title: "Subscription Plans",
            details: { status: data.status === 'ACTIVE' ? 'INACTIVE' : 'ACTIVE' }
        })
    }

    useEffect(() => {
        if (prevEditDetails !== undefined && editDetails && prevEditDetails !== editDetails) {
            toast.dismiss();
            toast(`"${editData.planId}" has been ${editData.status} successfully`);
            dispatchFilter(sortBy, sortOrder);
        }
    }, [editDetails]);

    return (
        <React.Fragment>
            <MainHeader {...props} img={SettingsImg}
                title={'Younote Admin'} links={[{ 'label': 'Younote Admin', 'link': '/younote-admin' }, { 'label': 'Plan Details', 'link': '' }]} />
            <div className={clsx(classes.margin40, classes.listTableMargin)}>
                <PrimaryCard
                    title={'Plan Details'}
                    component={
                        <>
                            <Row align="middle" className={classes.marginBottom20}>
                                <Col xxl={6} xl={7} lg={8} md={10} sm={13} xs={24}>
                                    {
                                        roleManagement !== '' && checkComponentPermission('Plan Details', 'Action', 'Search') &&
                                        <div className={clsx(classes.searchAnimation, { [classes.iconAnimation]: iconAnimation })}>
                                            <TextField autoComplete='one-time-code'
                                                placeholder='Search'
                                                type='search'
                                                className={classes.comInput}
                                                required
                                                variant={'standard'}
                                                onChange={(e) => setSearch(e.target.value)}
                                                fullWidth
                                                onFocus={() => setIconAnimation(true)}
                                                onBlur={() => setIconAnimation(false)}
                                            />
                                            <Image src={SearchIcon} preview={false} />
                                        </div>
                                    }
                                </Col>
                                <Col xxl={18} xl={17} lg={16} md={14} sm={11} xs={24} className={clsx(classes.textAlignRight, classes.vertiCalScrollOverFlowParent)}>
                                    <div className={classes.vertiCalScrollOverFlow}>
                                        <Space size={[20, 20]} direction="horizontal" align="center">
                                            {
                                                roleManagement !== '' && checkCRUDPermission('Plan Details', 'create', 'Younote Admin') &&
                                                <NavLink
                                                    to={`/younote-admin/common/plan-details/create`}
                                                    className={clsx(classes.customLink)}>
                                                    <Image
                                                        src={AddIcon}
                                                        preview={false}
                                                        className={clsx(classes.antImage)}
                                                    /> <span className={clsx(classes.addLink, classes.color, classes.bold)}>Add Plan Detail</span>
                                                </NavLink>
                                            }
                                            {
                                                roleManagement !== '' && checkComponentPermission('Plan Details', 'Action', 'Filter') &&
                                                <></>
                                            }
                                        </Space>
                                    </div>
                                </Col>
                            </Row>
                            <ListTable
                                onDelete={(data) => onDelete(data)}
                                loadTasks={() => dispatchFilter(sortBy, sortOrder)}
                                details={getList}
                                loadMore={loadMore}
                                loadMoreTask={() => loadMoreTask()}
                                loadMoreContent={loadMoreContent}
                                sortOrder={sortOrder}
                                sortBy={sortBy}
                                roleManagement={roleManagement}
                                handleStatus={(data) => handleStatus(data)}
                                onRequestSort={(sortBy, sortOrder) => requestSort(sortBy, sortOrder)}
                            />
                        </>
                    }
                />
            </div>
            <DeleteModal onClose={(v) => setDeleteModal(v)}
                id={providerId} loadTasks={() => dispatchFilter(sortBy, sortOrder)} name={name} url={'plans'}
                title={'Plan Details'} visible={deleteModal} />
        </React.Fragment>
    )
}

export default PlanDetails